import CustomerProfileAdvancedForm from './CustomerProfileAdvancedForm'

export default CustomerProfileAdvancedForm
